export default "__VITE_ASSET__qVjna2Qc__"